import ApiService from './ApiService';

class MetaService extends ApiService {
    constructor() {
        super();
    }

    getMeta(url){
        const header = this.getLangHeader();
        this.setRequestHeaders(header);

        return this.getResource(this.getMetaUrl() + url);
    };

    getMetaUrl(){
        return '/meta'
    }
}

const service = new MetaService();

export default service;
